module.exports = __webpack_public_path__ + "static/img/tabsbg01.2fa5f871.png";